import NoDataBox from '@root/assets/svg/Status/NoDataBox';

const NoData = ({
  message = undefined,
  height = '100%',
  hideImage = false,
  imageheight = undefined,
  imageWidth = undefined,
  // isEventsTable = false,
  // fetchTimeRange
}) => (
  <div
    style={{
      position: 'relative',
      height: height,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    }}>
    {!hideImage && <NoDataBox height={imageheight || '80px'} width={imageWidth || '80px'} />}
    <div style={{ fontFamily: 'Manrope', fontSize: '14px', color: '#484D56', fontWeight: '600' }}>
      {
        // isEventsTable && fetchTimeRange && fetchTimeRange === '24h'
        //   ? `Sorry, we couldn’t find any data in last ${fetchTimeRange}`
        //   :
        message || `Sorry, we couldn't find any data!`
      }
    </div>
  </div>
);

export default NoData;
